<template>
  <div class="app">
    <nav class="menu">
      <div class="content">
        <img src="../assets/logo.png"/>
        <span class="name">消考实操模拟软件</span>
        <div class="right-menu" @click="visible=true">
          <!-- <span class="free" @click="cvisible=true">领取免费账号</span> -->
          <img class="ask-help" src="../assets/help-ask.png"/>  <span >常见问题</span>
        
      </div>
      </div>
    </nav>
    <div class="container">
      <div class="main-wrapper index">
        <div class="main index">
          <div class="index-content">
            <div class="title">
              <div>消考实操模拟软件</div>
              <!-- <div class="subfix">国考仿真版</div> -->
            </div>
            <div class="sub-title">
           <div class="pc-down">
            <img class="subtitle-icon" src="../assets/pc-dload.png" alt=""> 
            <div class="pc-down-text">
              <div class="pc">电脑版用户点击下方按钮免费下载</div>
              Windows / Mac 客户端均可进行实操模拟
            </div> 
           </div> 
           <div  class="phone-down">
            <img class="subtitle-icon" src="../assets/phone-dload.png" alt=""> <span class="phone-tip">手机版用户扫描右侧二维码, 下载消考实操模拟软件APP</span>
           </div> 
           <!-- <div  class="organize">
            <img class="subtitle-icon" src="../assets/organize.png" alt=""> 
              <span><i>机构用户</i>联系微信：windswept1，开通机构版使用权限</span>
           </div> -->
           <div class="buttons">
              <div class="pc" @click="downloadClient"><img src="../assets/pc.png" /><span>{{ text }}</span></div>
            </div>
            </div>
          </div>
          <div class="video"><img src="../assets/video.png"/>
          <div class="app">
          <!-- <div class="ddd mini-code">
            <div class="qrcode">
              <img src="../assets/wechat-mini.png"/>
            </div>
           <span>微信小程序</span>
           
          </div> -->
          <div class="ddd">
            <div class="qrcode">
              <img src="../assets/ios-download.png"/>
            </div>
            <span>苹果 iOS</span>
            
          </div>
          <div class="ddd">
            <div class="qrcode">
              <img :src="qrcode"/>
            </div>
            <span>安卓</span>
           
        </div></div>
        </div>
       
      </div>
      </div>
      <div class="main-wrapper jobs">
        <div class="main">
          <h3 class="color">“零”基础轻松过关</h3>
          <div class="items">
            <div class="item">
              <img src="../assets/func1.png"/>
            </div>
            <div class="item">
              <img src="../assets/func2.png"/>
            </div>
            <div class="item">
              <img src="../assets/func3.png"/>
            </div>
            <div class="item">
              <img src="../assets/func4.png"/>
            </div>
            <div class="item">
              <img src="../assets/func5.png"/>
            </div>
            <div class="item">
              <img src="../assets/func6.png"/>
            </div>
            <div class="item">
              <img src="../assets/func7.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="main-wrapper mutil">
        <div class="main">
          <h3><span class="muti-color">“多”终端兼容</span> 到哪都能学</h3>
          <p class="muti-tip">消考实操模拟软件目前已支持Windows系统（32位/64位）、MacOS系统、苹果手机、安卓手机、微信小程序</p> 
          <img src="../assets/mutil.png" style="width:80%;margin-top:83px ;"/>
        </div>
      </div>
      <!-- <div class="main-wrapper hezuo">
        <div class="main">
          <h3>合作机构</h3>
          <p>机构用户可以咨询微信：windswept1，<span>开通机构专版</span></p>
          <div class="lists">
            <div><img src="../assets/xintai.jpeg"/></div>
            <div><img src="../assets/tianlan.jpeg"/></div>
            <div><img src="../assets/hengyuan.jpeg"/></div>
            <div><img src="../assets/junhe.jpeg"/></div>
            <div><img src="../assets/jindun.jpeg"/></div>
         
          </div>
        </div>
      </div> -->
      <div class="main-wrapper demo">
        <div class="main">
          <h3 class="color">界面演示</h3>
          <div class="demo-tip">iOS & 安卓移动端界面展示</div>
          <div class="lists">
            <div class="item">
              <img src="../assets/demo1.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo6.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo2.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo3.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo4.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo5.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo7.png"/>
            </div>
            <div class="item">
              <img src="../assets/demo8.png"/>
            </div>
          </div>
        </div>
      </div>
      <div class="main-wrapper footer">
        <div class="main" style="font-weight:normal">
          Copyright &COPY; 2025 www.xiaokaoshicao.cn  <a href="https://beian.miit.gov.cn" style="color:#fff;text-decoration: none;">沪ICP备2024055314号-35</a>
        </div>
      </div>
    </div>
    <div class="popup" v-show="visible">
      <div class="p-body">
        <div class="p-title" @click="visible=false">
          <div>常见问题</div>
          <img src="../assets/close.png" alt="">
        </div>
        <div class="p-content">
          <p class="q">问:  32 位系统安装包怎么下载?</p>
          <p class="a">答:  32 位系统已经在官网首页适配展示为“点击下载windows客户端（32位）”，点击按钮即可以下载32位安装包</p>
        </div>
        <div class="line"></div>
        <div class="p-content">
          <p class="q">问:  仿真功能白屏怎么办?</p>
          <p class="a">答:  消考实操在window 7 sp1版本的操作系统下会出现白屏现象，解决方案如下：1、关闭360、腾讯管家和消考实操；2、打开链接<a href="https://www.wosign.com/download/winroot.htm" target="_blank">证书下载</a>，点击页面中“下载”，下载完成后，双击安装证书；3、安装证书完成后，重新启动消考实操，即可解决白屏问题。</p>
        </div>
      </div>
    </div>
    <!-- <div class="popup" v-show="cvisible">
      <div class="p-body">
        <div class="p-title">免费领取账号<span @click="cvisible=false">x</span></div>
        <div class="p-content">
          <p>联系电话：13899999999（微信同号）</p>
          <div>
            <span>公司名称：</span>
            <div><input type="text"/></div>
          </div>
          <div><span>联系人：</span><div><input type="text"/></div></div>
          <div><span>联系电话：</span><div><input type="text"/></div></div>
          <p></p>
        </div>
      </div>
    </div> -->
  </div>
</template>

<script>
import yaml from 'js-yaml'
import axios from 'axios'
import QRCode from 'qrcode'
export default {
  name: 'app',
  data() {
    return {
      showios: false,
      showand: false,
      download: '',
      config: '',
      text: '点击下载Windows客户端 (64位)',
      visible: false,
      cvisible: false,
      qrcode: ''
    };
  },
  created() {
    console.log('=====')
    // window.location.href = 'https://www.xiaokaoshicao.com'
    this.genAndroidCode()
  },
  methods: {
    showcode(key) {
      if (key === 'ios') {
        this.showios = true
      } else {
        this.showand = true
      }
    },
    hidecode(key) {
      if (key === 'ios') {
        this.showios = false
      }else{
        this.showand = false
      }
    },
    async getPosType() {
      var agent = navigator.userAgent.toLowerCase();
      var isMac = /macintosh|mac os x/i.test(navigator.userAgent);
      if (agent.indexOf("win32") >= 0 || agent.indexOf("wow32") >= 0) {
          const yml = await this.loadFile('https://xfsc.firepal.cn/update_caizhu/win32/ia32/latest.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update_caizhu/win32/ia32/' + config.files[0].url
          this.text = '点击下载Windows客户端 (32位)'
      }
      if (agent.indexOf("win64") >= 0 || agent.indexOf("wow64") >= 0) {
          const yml = await this.loadFile('https://xfsc.firepal.cn/update_caizhu/win32/x64/latest.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update_caizhu/win32/x64/' + config.files[0].url
          this.text = '点击下载Windows客户端 (64位)'
      }
      if (isMac) {
          const yml = await this.loadFile('https://xfsc.firepal.cn/update_caizhu/darwin/latest-mac.yml')
          const config = yaml.load(yml)
          this.download = 'https://xfsc.firepal.cn/update_caizhu/darwin/' + config.files[1].url
          this.text = '点击下载 MAC 客户端'
      }
    },
    async loadFile(url) {
      return await axios.get(url, {
        withCredentials: false,
      }).then(res => res.data)
    },
    downloadClient(){
      location.href = this.download
    },
    async genAndroidCode() {
      const config = await this.loadFile('https://register.firepal.cn/data/caizhu_config.json')
      this.qrcode = await QRCode.toDataURL(config.update.download, {margin: 2})
    }
  },
  mounted() {
    this.getPosType()
  }
};
</script>

<style lang="less">
@font-face {
	  font-family: 'Truth';
	  src: url('../assets/fonts/truth.woff') format('woff'), url('../assets/fonts/truth.otf') format('otf'), url('../assets/fonts/truth.ttf') format('opentype');
	  font-style: normal;
	  font-weight: normal;
	}
html,
body {
  margin: 0;
  padding: 0;
  /* height: 100%; */
  width: 100%;
  /* overflow: hidden; */
  font-family: "microsoft yahei", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #fff;
}
.app {
  /* height: 100%; */
  // width: 100%;
  margin-top: 77px;
  
}
p {
  /* margin: 0; */
  /* text-align: center; */
  /* width: 800px; */
  margin: 0 auto;
}
h1,h3,h4,h2,h5{
  padding: 0;
  margin: 0;
}
h3{
  font-size: 36px;
  margin-bottom: 20px;
  font-family: 'Truth';
  font-weight: normal;
}
html,
body,
#app {
  height: 100%;
  margin: 0;
  padding: 0;
}
.container{
  width: 100%;
}

.menu{
  position: absolute;
  left: 0;
  right: 0;
  top: 0;
  background: #FFF;
  .content{
    width: 1200px;
    margin: 0 auto;
    color: #fff;
    display: flex;
    align-items: center;
    padding: 12px 0;
    font-size: 24px;
    // justify-content: space-between;
    img{
      width: 50px;
      height: 50px;
      margin-right: 15px ;
      // border-radius: 10px;
    }
    .name{
      color: #376FF6;
      font-size: 20px;
      // font-weight: 800;
      font-family: 'Truth';
      color: #4B74CD;
      font-size: 22px;
      letter-spacing: -0.72px;
    }
  }
  .right-menu{
    display: flex;
    align-items: center;
    cursor: pointer;
    font-weight: 500;
    margin-left: auto;
    color: #1A1A1A;
    font-size: 14px;
    font-weight: 400;
    .ask-help{
      width: 22px;
      height: 22px;
      margin-right: 8px;
    }
  }
  .free{
    margin-right: 30px;
    color: #376FF6;
    position: relative;
    &::before{
      content: '免费';
      font-size: 6px;
      position: absolute;
      right: -20px;
      top: -15px;
      background-color: #CE5653;
      color: #fff;
      padding: 0 5px;
      border-radius: 10px;
    }
  }
}

.main{
  width: 1200px;
  margin: 0 auto;
  text-align: center;
  /* display: inline-block; */
  &.index{
    margin-top: 90px;
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    // align-items: center;
    justify-content: space-between;
    
    h1{
      font-size: 48px;
    }
    h4{
      font-size: 36px;
      font-weight: 400;
      margin-top: 20px;
      margin-bottom: 50px;
    }
    .video{
      margin-top: -20px;
      width: 600px;
      height: 320px;
      // background: #f1f1f1;
      img{
        width: 600px;
      height: 320px;
      }
    }
    
  }
  &.resume{
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
.button-code{
  width: 190px;
  height: 50px;
  border-radius: 50px;
  background: #fff;
  margin-bottom: 20px;
  display: flex;
  align-items: center;
  text-align: center;
  justify-content: center;
  color: #333;
  cursor: pointer;
  img{
    width: 20px;
    height: 22px;
    margin-right: 20px;
  }
}
.index-phone {
  display: inline-block;
  img{
    width: 264px;
    margin-right: 150px;
  }
}
.index-content{
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  .title{
    color: #F7D490;
    font-size: 50px;
    font-style: normal;
    font-weight: 500;
    font-family: 'Truth';
    display: flex;
    flex-direction: column;

    align-items: flex-start;
    div{
      
      span:first-child{
        color: #CE5653;
        font-family: 'Truth';
        font-size: 54px;
      }
    }
    
    .subfix{
      // font-family: 'Truth';
      color: #F7D490;
      font-size: 40px;
      font-weight: 400;
    }
  }
  .sub-title{
    margin-top: 90px;
    font-size: 14px;
    color: #333;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    height: 100px;
    justify-content: space-between;
    .pc-down{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 20px;
      .pc-down-text{
        text-align: left;
        color: #FFF;
          font-family: PingFang SC;
          font-size: 14px;
        .pc{
          color: #FFF;
        font-family: Alibaba PuHuiTi 2.0;
        font-size: 16px;
        font-weight: 600;

        }
      }
   
    }
    .phone-down{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
      margin-bottom: 20px;
    
      .phone-tip{
        color: #FFF;
        font-family: Alibaba PuHuiTi 2.0;
        font-size: 16px;
        font-weight: 600;
      }
    }
    .organize{
      display: flex;
      flex-direction: row;
      align-items: center;
      justify-content: flex-start;
 span {
  color: #FFF;
font-family: Alibaba PuHuiTi 2.0;
font-size: 16px;
font-weight: 600;
i{
  color: #F7D490;
}
 }
    }
    i{
      color: #CE5653;
      font-style: normal;
    }
    .h5{
      display: none;
    }
    span{
      // position: relative;
      // padding-left: 20px;
      // &::before{
      //   position: absolute;
      //   width: 0;
      //   height: 0;
      //   border-left: 6px solid transparent;
      //   border-right: 6px solid transparent;
      //   border-bottom: 6px solid #333;
      //   font-size: 0;
      //   line-height: 0;
      //   transform: rotate(90deg);
      //   display: inline-block;
      //   content: "";
      //   left: 0;
      //   top: 50%;
      //   margin-top: -3px;
      // }
    }
  }
}
.subtitle-icon{
        width: 50px;
        height: 50px;
        margin-right: 12px;
      }
.buttons{
  
  .pc{
    display: flex;
    align-items: center;
    justify-content: center;
    width: 461px;
    height: 58px;
    margin-top: 40px;
    border-radius: 10px;
    background: #FFF;
    cursor: pointer;
    img{
      height: 20px;
      margin-right: 10px;
    }
    span{
      color: #7398DE;
      text-align: center;
      font-family: Alibaba PuHuiTi 2.0;
      font-size: 16px;
      font-weight: 600;
    }
  }
  
}
.main-wrapper{
  width: 100%;
  display: inline-block;
  &.index{
    height: 678px;
    // background: url('../assets/bgggg.png');
    background-size: 100% auto;
    background: linear-gradient(180deg, #4A73CC 0%, #E2ECFF 100%);
    .app{
      display: flex;
      flex-direction: row;
      justify-content: flex-end;
      margin-right: 25px;
      // width: 1200px;
      // margin: 60px auto 50px auto;
      .ddd{
        display: flex;
        flex-direction: column;
        align-items: center;
        justify-content: center;
        cursor: pointer;
        position: relative;
        margin-left: 54px;
        color: #333;
        .qrcode{
          // position: absolute;
          // left: 50%;
          // transform: translateX(-50%);
          // top: 70px;
          // box-sizing: border-box;
          // border: 5px solid #fff;
          // background-color: #fff;
          border-radius: 6px;
          width: 89px;
          height: 89px;
          margin-bottom: 12px;
          // &::before{
          //   width: 0;
          //   height: 0;
          //   border-bottom: 10px solid #fff;
          //   border-left: 10px solid transparent;
          //   border-right: 10px solid transparent;
          //   font-size: 0;
          //   line-height: 0;
          //   top: -14px;
          //   left: 50%;
          //   transform: translateX(-50%);
          //   display: inline-block;
          //   content: "";
          //   position: absolute;
          //   z-index: 9999;
          // }
          img{
            width: 89px;
          height: 89px;
          border-radius: 6px;
          }
        }
      }
    }
  }
  &.jobs{
    background: #fff;
    text-align: center;
    color: #333;
    padding-top: 90px;
  }
  &.resume {
    /* width: 100%; */
    position: relative;
    margin-top: 50px;
    text-align: center;
    color: #333;
    img{
      width: 800px;
      padding: 100px 0 50px;
    }
    &::before{
      width: 140%;height: 780px;
    }
    h3{
      margin-top: 50px;
    }
  }
  &.many{
    text-align: center;
    color: #333;
    padding: 50px 0;
    img{
      width: 1000px;
      margin-top: 80px;
    }
  }
  &.demo{
    h3{
      margin-top: 60px;
      color: #61637C;
    
    }
    .lists{
      display: flex;
      align-items: center;
      flex-wrap: wrap;
      justify-content: space-evenly;
      margin-top: 60px;
      .item{
        margin-bottom: 40px;
      }
      img{
        width:571px;
        height: 288px;
        // border-radius: 28px;
      }
    }
  }
  &.footer{
    background: #61637C;
    padding: 27px 0;
    text-align: center;
  }
}
.popup{
  position: fixed;
  left: 0;
  top: 0;
  right: 0;
  bottom: 0;
  z-index: 999;
  background-color: rgba(0, 0, 0, 0.6);
  .p-body{
    position: absolute;
    width: 525px;
    height: 400px;
    background: #fff;
    color: #333;
    box-sizing: border-box;
    border-radius: 10px;
    box-shadow: 0px 4px 10px 0px rgba(0, 0, 0, 0.10);
    padding: 30px;
    left: 50%;
    top: 50%;
    transform: translate(-50%,-50%);
  }
  .p-title{
    display: flex;
    flex-direction: row;
    justify-content: space-between;
    margin-bottom: 20px;
    div{
      color: #61637C;
      text-align: center;
      font-size: 16px;
      font-weight: 600;
    }
    img{
      width: 22px;
      height: 22px;
    }
   
    span{
      position: absolute;
      top: 20px;
      right: 20px;
      font-size: 30px;
      font-weight: 100;
      cursor: pointer;
      padding: 0 5px;
    }
  }
  p{
    line-height: 2;
    &.q{
      font-weight: 500;
      margin: 10px 0;
    }
    &.a{
      color: #666;
      font-size: 16px;
    }
  }
}
.items{
  display: flex;
  align-items: center;
  flex-wrap: wrap;
  justify-content: space-between;
  margin-top: 47px;
  margin-bottom: 110px;
  .item{
    width: 274px;
    text-align: center;
    display: flex;
    // height: 101px;
    overflow: hidden;
    margin-bottom: 23px;
    img{
      width: 100%;
      // height: 101px;
    }
    &:last-child{
      width: 569px;
    }
  }
}
.mutil{
  padding: 71px 0;
  color: #333;
  background: linear-gradient(180deg, #B1CEF8 0%, rgba(173, 203, 246, 0.00) 100%);
  background-size: 100% auto;
}
.hezuo{
  color: #333;
  margin-top: 80px;
  margin-bottom: 80px;
  span{
    color: #CE5653;
  }
  .lists{
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    width: 1200px;
    margin: 0 auto;
    justify-content: space-between;
    margin-top: 40px;
    div{
      width: 240px;
      height: 240px;
      background: #fcfcfc;
      display: flex;
      align-items: center;
      justify-content: center;
      border-right: 1px solid #f4f4f4;
      border-bottom: 1px solid #f4f4f4;
      box-sizing: border-box;
      &:hover{
        background: rgba(55, 111, 246, 0.3);
      }
    }
    img{
      width: 120px;
      height: 120px;
      border-radius: 120px;
    }
  }
}
.color{
  color: #61637C;
}
.muti-color{
  color: #FFDA92
}
.muti-tip,.demo-tip{
  color: #FFF;
text-align: center;
font-family: Alibaba PuHuiTi 2.0;
font-size: 16px;
font-weight: 600;
}
.demo-tip{
  color: #61637C;

}
.main {h3{
  color:#61637C
}}
@media screen and (max-width: 768px) {
  .menu{
    .content{
      padding: 15px 20px;
      width: 100%;
      box-sizing: border-box;
    }
    .right-menu{
      display: none;
    }
  }
  .index-content{
    .title{
      font-size: 30px;
      // flex-direction: column;
      align-items: flex-end;
      div{      
        span:first-child{
          color: #CE5653;
          font-family: 'Truth';
          font-size: 30px;
        }
      }
      .subfix{
        // margin-left: 0;
        font-size: 17px;
        // margin-top: 10px;
      }
    }
  }
  .sub-title{
    
    .pc,.phone{
      display: none;
    }
    span::before{
      top:8px !important;
      margin-top: 0 !important;
    }
  }
  .index-content .sub-title{
    margin-top: 20px;
  }
  .h5{
      display: inline-block !important;
      margin-bottom: 5px;
    }
  .buttons{
    display: none;
  }
  .main.index{
    flex-direction: column;
    width: 100%;
    margin-top: 10px;
    box-sizing: border-box;
    padding: 0 20px;
    justify-content: center;
    .video {
      width: 100%;
      height: auto;
      margin-top: 115px;
      img{
        width: 100%;
        height: auto;
      }
    }
  }
  .main-wrapper.index{
    background-repeat: no-repeat;
    background-size: auto 100%;
    height: 670px;
    .app{
      margin-top: 23px;
      justify-content: center;
      .mini-code{
        display: none;
      }
      span{
        color: #61637C;
          }
      //
    }
  }
  .main-wrapper.jobs{
    display: none;
  }
  .main{
    width: 100%;
  }
  .hezuo{
    margin-top: 40px;
    margin-bottom: 40px;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  .hezuo .lists{
    width:100%;
    justify-content: center;
    div{
      width: 50%;
    }
  }
  .main-wrapper.demo {
    .lists{
      box-sizing: border-box;
      padding: 0 20px;
      .item{
        margin-bottom: 20px;
      }
      img{
        width:100%;
        height: auto;
      }
    }
  }
  .main-wrapper.footer{
    font-size: 14px;
  }
  .mutil{
    background-size: auto 100%;
    p{
      padding: 0 20px;
      box-sizing: border-box;
    }
  }
  h3{
    font-size: 28px;
  }
  p,span{
    text-align: left;
  }
  .index-content .title{
    align-items: flex-start;
  }
}
.line {
  margin: 30px 0;
  width: 464px;
height: 1px;
background: #DCDCDC;
}
</style>
